import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DocumentService } from 'src/app/core/services/document.service';

@Component({
  selector: 'app-signing-dialog-report',
  templateUrl: './signing-dialog-report.component.html',
  styleUrls: ['./signing-dialog-report.component.scss']
})
export class SigningDialogReportComponent implements OnInit, OnDestroy {

  public displayedColumns = [
    'stt',
    'name',
    'status'
  ];
  public cancelFlow = false;
  data: any = [];

  constructor(
    public dialogRef: MatDialogRef<SigningDialogReportComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private documentService: DocumentService,
  ) {
  }
  ngOnDestroy(): void {
    clearInterval(this.dataDialog.signingInteval);
  }


  ngOnInit() {
    console.log("processing", this.dataDialog.signProcessing);
    this.data = this.preProcessSignProcessing();
    this.subscribeData();
    this.initData();

  }

  initData() {
    this.documentService.setCancelFlow(false);
    this.dataDialog.resetValue();
  }

  subscribeData() {
    this.documentService.cancelFlow.subscribe(status => {
      if (status != null || status != undefined) {
        this.cancelFlow = status
      }
    });
  }


  renderNameFile(fileId: number) {
    const file = this.dataDialog.document.mainContractAttachments.find(item => item.id === fileId);
    return file && file.fileName ? file.fileName : '';
  }

  renderNumberProcessing() {
    const doneSign = this.data.filter(item => {
      return item.done;
    });
    return doneSign.length;
  }

  preProcessSignProcessing(){
    const checkData = new Set();
    const list = new Array<any>();
    for (let i = 0; i < this.dataDialog.signProcessing.length; i++) {
        if (!checkData.has(this.dataDialog.signProcessing[i].fileId)) {
          checkData.add(this.dataDialog.signProcessing[i].fileId);
          list.push(this.dataDialog.signProcessing[i]);
        }
    }
    console.log("list: ", list);
    return list;
  }
}
